import React from 'react'
import { Avatar } from 'antd'
import { getNameSignature, turncateText } from 'helper/utility'
import '../styles/styles.scss'
import { eventShatStore } from 'state/event/eventChat'

interface ChatMainInfoProps {
  avatar: string | undefined
  id: string
  name: string
  createdBy: string
  lastMessage: string
  time: string
  active?: boolean
  setActiveChatRoom?: React.Dispatch<React.SetStateAction<string>>
  scheduled?: boolean
}

const ChatMainInfo: React.FC<ChatMainInfoProps> = ({
  avatar,
  id,
  name,
  createdBy,
  lastMessage,
  time,
  active,
  setActiveChatRoom,
  scheduled,
}) => {
  const { setScheduleForId, setScheduleModalVisible } = eventShatStore(
    store => ({
      setScheduleForId: store.setScheduleForId,
      setScheduleModalVisible: store.setScheduleModalVisible,
    }),
  )

  return (
    <div
      className={`pointer py-15px px-20px flex justify-between mt-5px border-btm ${
        active && 'bg-colored'
      }`}
      onClick={() => {
        if (!scheduled) {
          setActiveChatRoom(id)
        } else {
          console.log(id, 'id where assigning')
          setScheduleForId(id)
          setScheduleModalVisible(true)
        }
      }}
    >
      <div className="flex gap-10px">
        <Avatar size={45} src={avatar}>
          {getNameSignature(name)}
        </Avatar>
        <div>
          <h2 className="text-16 w-500">{name}</h2>
          <p className="text-14 w-400 text-gray">{createdBy}</p>
          <p className="text-14 w-400">{turncateText(lastMessage, 25)}</p>
        </div>
      </div>
      <p className="text-12 w-400">{time}</p>
    </div>
  )
}

export default ChatMainInfo
